export default {"src":"/_next/static/media/filterIcon.59340f64.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};